import styled from 'styled-components';
import { styles } from '../../../consts';

const { fontMontserrat, white, textColorGray } = styles;

const ConcealableWrapper = styled.div``;

const Seller = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  line-height: 1.5rem;
  color: ${textColorGray};
`;

const Amount = styled.div`
  display: flex;
  justify-content: space-between;
  font-style: normal;
  font-stretch: normal;
  height: 1.5rem;
`;

const AmountText = styled.p`
  font-family: ${fontMontserrat};
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.03125rem;
  line-height: 1.5rem;
`;

const AmountNumber = styled.p`
  line-height: 1.5rem;
`;

const Integer = styled.span`
  font-family: ${fontMontserrat};
  font-size: 1.125rem;
  font-weight: 600;
  letter-spacing: normal;
  text-align: right;
  color: ${white};
`;

const Decimal = styled.span`
  height: 1rem;
  font-family: ${fontMontserrat};
  font-size: 0.875rem;
  font-weight: 300;
  text-align: right;
  text-transform: uppercase;
  letter-spacing: 0.03125rem;
`;

export { Amount, AmountText, ConcealableWrapper, AmountNumber, Integer, Decimal, Seller };
